module.exports = __webpack_public_path__ + "static/koa-f5abaf4ba30b0e0befae0fe7a9d3247d.jpg";